import { p as proxyCustomElement, H, h } from './p-ae815584.js';
import { b as bem } from './p-c44c2366.js';

const cosmosLinkCss = "@-webkit-keyframes cosmos-link-dim-border{0%{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}100%{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}}@keyframes cosmos-link-dim-border{0%{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}100%{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}}.cosmos-link{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:0;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-variation-settings:inherit;font-weight:inherit;line-height:inherit;margin:0;outline:none;padding:0;color:inherit;font:inherit;font-variant-numeric:inherit;letter-spacing:inherit;position:relative;text-align:inherit;text-decoration:none}.cosmos-link:not(:focus):hover{-webkit-animation:none;animation:none;border-color:currentColor;-o-border-image:none;border-image:none}.cosmos-link:focus-visible{border-radius:0.2em;-webkit-box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;margin:0 -2px;padding:0 2px;text-decoration:none}.cosmos-link--kind-underlined{text-decoration:underline;text-decoration-thickness:0.105em;text-transform:inherit;text-underline-offset:0.125em}.cosmos-link--kind-underlined:not(:focus){-webkit-animation:1s cosmos-link-dim-border steps(2, start) infinite paused;animation:1s cosmos-link-dim-border steps(2, start) infinite paused}";
const CosmosLinkStyle0 = cosmosLinkCss;

const generateClassNames = bem('cosmos-link');
const CosmosLink$1 = /*@__PURE__*/ proxyCustomElement(class CosmosLink extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleKeyDown = (event) => {
            if (this.href)
                return;
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                event.target.click();
            }
        };
        this.href = undefined;
        this.kind = 'underlined';
        this.rel = undefined;
        this.target = undefined;
    }
    render() {
        const Tag = this.href ? 'a' : 'span';
        const role = Tag === 'span' ? 'button' : undefined;
        return (h(Tag, { key: '3237dc48728ce4f95bb281ca7f381a531e58e60b', class: generateClassNames({
                kind: this.kind,
            }), href: this.href, onKeyDown: this.handleKeyDown, part: "base", rel: this.rel, role: role, tabIndex: 0, target: this.target }, h("slot", { key: '6c8cdfaf2654250b85bc2cd7047a6b441cf30995' })));
    }
    static get style() { return CosmosLinkStyle0; }
}, [1, "cosmos-link", {
        "href": [513],
        "kind": [513],
        "rel": [513],
        "target": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-link"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-link":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosLink$1);
            }
            break;
    } });
}

const CosmosLink = CosmosLink$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosLink, defineCustomElement };
